export const buttonLengthConstants = {
  AUTO: 'AUTO',
  SHORT: 'SHORT',
  NORMAL: 'NORMAL',
  LONG: 'LONG',
};

export const buttonVariantConstants = {
  PRIMARY_CERULEAN: 'PRIMARY_CERULEAN',
  PRIMARY_ORANGE: 'PRIMARY_ORANGE',
  PRIMARY_PURPLE: 'PRIMARY_PURPLE',
  SECONDARY_CERULEAN: 'SECONDARY_CERULEAN',
  SECONDARY_ORANGE: 'SECONDARY_ORANGE',
  SECONDARY_PURPLE: 'SECONDARY_PURPLE',
  TERTIARY_CERULEAN: 'TERTIARY_CERULEAN',
  TERTIARY_ORANGE: 'TERTIARY_ORANGE',
  TERTIARY_PURPLE: 'TERTIARY_PURPLE',
};
